// extracted by mini-css-extract-plugin
module.exports = {"bb-stepper":"bb-stepper__Yq1b5"};